var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"input-orders"}},[_c('v-card',{staticClass:"px-5 py-2 mt-4 mb-5 elevation-0",attrs:{"id":"input-orders-card"}},[_c('div',{class:{ 'sticky-filters': _vm.user.preferences.stickyFilters }},[_c('CommonFilters',{ref:"commonFilters",attrs:{"type":"order"},on:{"filterElements":_vm.filterElements},scopedSlots:_vm._u([{key:"add-button",fn:function(){return [_c('AddButtons',{attrs:{"type":"order"},on:{"clicked":_vm.createOrder}}),(!_vm.isMobile)?[_c('ImportButton',{attrs:{"click":_vm.openImportModal}})]:_vm._e(),_c('MoreButtons',{attrs:{"buttons":_vm.moreButtons,"loading":_vm.exportLoading}})]},proxy:true}])})],1),_c('v-data-table',{staticClass:"elevation-0 mt-2",attrs:{"id":"input-orders-table","headers":_vm.headers,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.totalItems,"sort-by":"date","sort-desc":true,"mobile-breakpoint":"0","loading":_vm.loading,"no-data-text":_vm.$t('views.orders.noOrders'),"item-class":_vm.itemRowBackground,"footer-props":{
        'items-per-page-options': _vm.defaultPaginationItemsPerPageOptions,
      },"items-per-page":_vm.user.preferences.denseTables ? 15 : 10,"dense":_vm.user.preferences.denseTables},on:{"update:options":[function($event){_vm.options=$event},_vm.updateOptions]},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
      var item = ref.item;
return [_c('OrderTableTypeIcon',{attrs:{"item":item}})]}},{key:"item.date",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDateUserFormat(item.date))+" ")]}},{key:"item.broker.alias",fn:function(ref){
      var item = ref.item;
return [(
            [
              'buy',
              'sell',
              'switch',
              'switchBuy',
              'spinOff',
              'spinOffBuy',
              'brokerTransfer',
              'sharePremium',
              'scrip',
              'capitalIncrease',
              'bonus',
              'stakeReward',
              'drip',
              'optionBuy',
              'optionSell',
              'commission',
              'paidInterest',
              'interest',
              'interestRetention',
              'deposit',
              'withdrawal' ].indexOf(item.type) > -1
          )?[_c('TableBroker',{attrs:{"broker":item.broker,"newBrokerAlias":['brokerTransfer'].indexOf(item.type) > -1
                ? item.metadata.newBrokerAlias
                : undefined}})]:_c('span')]}},{key:"item.position.ticker",fn:function(ref){
                var item = ref.item;
return [_c('TableTicker',{attrs:{"position":item.position}})]}},{key:"item.positionNumber",fn:function(ref){
                var item = ref.item;
return [_c('div',{staticClass:"items-flex justify-end"},[(
              item.positionNumber &&
              [
                'buy',
                'sell',
                'switch',
                'switchBuy',
                'spinOff',
                'spinOffBuy',
                'sharePremium',
                'scrip',
                'capitalIncrease',
                'bonus',
                'stakeReward',
                'drip',
                'optionBuy',
                'optionSell',
                'commission',
                'paidInterest',
                'interest',
                'interestRetention',
                'deposit',
                'withdrawal',
                'brokerTransfer' ].indexOf(item.type) > -1
            )?_c('currency',{attrs:{"value":item.positionNumber,"currency":item.position.type === 'cash' ? item.position.ticker : undefined,"decimals":7,"strong":""}}):_c('span')],1)]}},{key:"item.price",fn:function(ref){
            var item = ref.item;
return [_c('div',{staticClass:"items-flex justify-end"},[(
              [
                'buy',
                'sell',
                'switch',
                'switchBuy',
                'sharePremium',
                'scrip',
                'capitalIncrease',
                'bonus',
                'stakeReward',
                'drip',
                'optionBuy',
                'optionSell',
                'commission',
                'paidInterest',
                'interest',
                'interestRetention',
                'deposit',
                'withdrawal' ].indexOf(item.type) > -1
            )?_c('currency',{attrs:{"value":item.price,"currency":item.position.currency,"decimals":3}}):_c('span')],1)]}},{key:"item.total",fn:function(ref){
            var item = ref.item;
return [(item.total)?_c('currency',{attrs:{"value":item.total,"currency":item.position.currency}}):_c('span')]}},{key:"item.totalBaseCurrency",fn:function(ref){
            var item = ref.item;
return [(item.totalBaseCurrency)?_c('currency',{attrs:{"value":item.totalBaseCurrency,"currency":_vm.user.baseCurrency}}):_c('span')]}},{key:"item.comission",fn:function(ref){
            var item = ref.item;
return [(
            [
              'buy',
              'sell',
              'switch',
              'switchBuy',
              'sharePremium',
              'scrip',
              'capitalIncrease',
              'bonus',
              'stakeReward',
              'drip',
              'optionBuy',
              'optionSell' ].indexOf(item.type) > -1
          )?_c('currency',{attrs:{"value":item.comission,"text-red":!!item.comission,"currency":item.comissionCurrency,"decimals":5}}):_c('span')]}},{key:"item.comissionBaseCurrency",fn:function(ref){
          var item = ref.item;
return [(
            [
              'buy',
              'sell',
              'switch',
              'switchBuy',
              'sharePremium',
              'scrip',
              'capitalIncrease',
              'bonus',
              'stakeReward',
              'drip',
              'optionBuy',
              'optionSell' ].indexOf(item.type) > -1 && item.comissionBaseCurrency
          )?_c('currency',{attrs:{"value":item.comissionBaseCurrency,"text-red":!!item.comissionBaseCurrency,"currency":_vm.user.baseCurrency}}):_c('span')]}},{key:"item.comissionPercentageOfTotalBaseCurrency",fn:function(ref){
          var item = ref.item;
return [(item.comissionPercentageOfTotalBaseCurrency)?[_vm._v(" "+_vm._s(_vm.round(item.comissionPercentageOfTotalBaseCurrency).toLocaleString())+"% ")]:void 0]}},{key:"item.taxes",fn:function(ref){
          var item = ref.item;
return [(['buy', 'sell'].indexOf(item.type) > -1)?_c('currency',{attrs:{"value":item.taxes,"text-red":!!item.taxes,"currency":item.taxesCurrency}}):_c('span')]}},{key:"item.exchangeRate",fn:function(ref){
          var item = ref.item;
return [(
            [
              'buy',
              'sell',
              'switch',
              'switchBuy',
              'sharePremium',
              'scrip',
              'capitalIncrease',
              'bonus',
              'stakeReward',
              'drip',
              'optionBuy',
              'optionSell' ].indexOf(item.type) > -1
          )?_c('TableExchangeRate',{attrs:{"item":item,"type":"order"},on:{"edit":function($event){return _vm.editOrder(item)}}}):_c('span')]}},{key:"item.totalWithComissionBaseCurrency",fn:function(ref){
          var item = ref.item;
return [(item.totalBaseCurrency)?_c('currency',{attrs:{"value":item.totalWithComissionBaseCurrency,"currency":_vm.user.baseCurrency,"strong":""}}):_c('span')]}},{key:"item.destinationRetentionBaseCurrency",fn:function(ref){
          var item = ref.item;
return [(item.destinationRetentionBaseCurrency)?_c('currency',{attrs:{"value":item.destinationRetentionBaseCurrency,"currency":_vm.user.baseCurrency}}):_c('span')]}},{key:"item.autoFx",fn:function(ref){
          var item = ref.item;
return [(
            [
              'buy',
              'sell',
              'switch',
              'switchBuy',
              'scrip',
              'sharePremium',
              'capitalIncrease',
              'bonus',
              'stakeReward',
              'drip',
              'optionBuy',
              'optionSell' ].indexOf(item.type) > -1 && item.position.currency !== _vm.user.baseCurrency
          )?_c('div',[(item.autoFx)?_c('v-icon',[_vm._v("mdi-toggle-switch")]):_c('v-icon',[_vm._v("mdi-toggle-switch-off-outline")])],1):_c('span')]}},{key:"item.deductible",fn:function(ref){
          var item = ref.item;
return [(item.deductible !== undefined)?_c('div',[(item.deductible)?_c('v-icon',[_vm._v("mdi-toggle-switch")]):_c('v-icon',[_vm._v("mdi-toggle-switch-off-outline")])],1):_c('span')]}},{key:"item.tags",fn:function(ref){
          var item = ref.item;
return [(item.tags.length)?_c('TagGroup',{attrs:{"tags":item.tags}}):_c('span')]}},{key:"item.actions",fn:function(ref){
          var item = ref.item;
return [(item.description)?[_c('v-tooltip',{attrs:{"top":"","max-width":"300px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-4",staticStyle:{"margin-top":"3px"},attrs:{"color":"secondary","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-message-bulleted ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.description))])])]:_vm._e(),(['switchBuy', 'spinOffBuy'].indexOf(item.type) === -1)?[(
              ['optionBuy', 'optionSell'].indexOf(item.type) > -1 &&
              item.position.positionNumber !== 0
            )?[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-3",attrs:{"size":"18"},on:{"click":function($event){return _vm.closeOptionOrder(item)}}},'v-icon',attrs,false),on),[_vm._v(" mdi-checkbox-multiple-outline ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('views.orders.ordersTable.closeOptionOrder.label')))])])]:_vm._e(),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"size":"16"},on:{"click":function($event){return _vm.duplicateOrder(item)}}},'v-icon',attrs,false),on),[_vm._v(" mdi-content-copy ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('views.orders.ordersTable.duplicateOrder')))])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"size":"18"},on:{"click":function($event){return _vm.editOrder(item)}}},'v-icon',attrs,false),on),[_vm._v(" mdi-pencil-outline ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('common.edit')))])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
            var on = ref.on;
            var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"size":"18"},on:{"click":function($event){return _vm.deleteOrder(item)}}},'v-icon',attrs,false),on),[_vm._v(" mdi-delete-outline ")])]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t('common.delete')))])])]:_vm._e()]}}])}),_c('OrdersButtonsModal',{attrs:{"isModalActive":_vm.isOrdersButtonsModalActive},on:{"update:isModalActive":function($event){_vm.isOrdersButtonsModalActive=$event},"update:is-modal-active":function($event){_vm.isOrdersButtonsModalActive=$event},"selected":_vm.createOrder}}),_c('OrderModal',{attrs:{"isModalActive":_vm.isOrderModalActive,"typeOrderModal":_vm.typeOrderModal,"subTypeOrderModal":_vm.subTypeOrderModal,"editing":_vm.editing,"editItem":_vm.editItem,"duplicating":_vm.duplicating},on:{"update:isModalActive":function($event){_vm.isOrderModalActive=$event},"update:is-modal-active":function($event){_vm.isOrderModalActive=$event},"saved":function (obj) { return _vm.loadItems(Object.assign({}, obj)); }}}),_c('ImportModal',{ref:"ImportModal",attrs:{"isModalActive":_vm.isImportModalActive,"type":"order"},on:{"update:isModalActive":function($event){_vm.isImportModalActive=$event},"update:is-modal-active":function($event){_vm.isImportModalActive=$event},"init":_vm.loadItems}}),(_vm.isHeadersModalActive)?_c('HeadersModal',{attrs:{"isModalActive":_vm.isHeadersModalActive,"tableName":_vm.tableName,"defaultHeaders":_vm.defaultHeaders},on:{"update:isModalActive":function($event){_vm.isHeadersModalActive=$event},"update:is-modal-active":function($event){_vm.isHeadersModalActive=$event}}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }